import { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { getDownloadUrl } from '@/utils';
import { useGetParentLettersQuery } from '@/services/parent-api';
import { DownloadSvg } from '@/assets/icons';
import Table from '@/components/table';
import Button from '@/components/button';

const LettersModal = ({ parentId, recommendationHistoryId, open, onClose }) => {
  const [pageNumber, setPageNumber] = useState(1);

  const { data, isFetching } = useGetParentLettersQuery(
    { parentId, parentRecommendationHistoryId: recommendationHistoryId, pageNumber, pageSize: 5 },
    { skip: !open },
  );

  useEffect(() => {
    if (!open) {
      setPageNumber(1);
    }
  }, [open]);

  const columns = [
    {
      title: 'Letter',
      dataIndex: 'letterName',
    },
    {
      title: 'Sent To',
      key: 'sent-to',
      render: (_, record) => record.letterRecipient.recipientType.name,
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (_, record) =>
        record.letterBlob.blobId ? (
          <Button
            type="link"
            href={getDownloadUrl(`/parents/${parentId}/letters/${record.parentLetterId}/download`)}
            icon={<DownloadSvg />}
            title="Download"
          />
        ) : (
          'Pending Generation'
        ),
    },
  ];

  return (
    <>
      <Modal
        title="View Letters"
        open={open}
        cancelText="Close"
        onCancel={onClose}
        width={800}
        footer={(_, { CancelBtn }) => <CancelBtn />}
      >
        <Table
          columns={columns}
          dataSource={data?.data}
          rowKey="parentLetterId"
          loading={isFetching}
          size="small"
          pagination={
            data?.count > data?.pageSize && {
              size: 'small',
              showQuickJumper: true,
              showSizeChanger: false,
              total: data.count,
              pageSize: data.pageSize,
              current: data.pageNumber,
              onChange: setPageNumber,
            }
          }
        />
      </Modal>
    </>
  );
};

export default LettersModal;
